export default __webpack_public_path__ + "static/media/undraw_articles_wbpb.fa4b8f55.png";